module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-hocker-02.21e993e1.jpeg";